import React, {Fragment} from 'react';
import type {Node} from 'react';
import type {FieldTransformer} from 'sulu-admin-bundle/types';
import {Input} from 'sulu-admin-bundle/components';
import {FieldTypeProps} from 'sulu-admin-bundle/types';

export default class ArrayImplodeTransformer implements FieldTransformer {
    transform(value: *): Node
    {
        try
        {
            let webspaces = value.$mobx['values'].join(', ');

            let style = {
                maxWidth: "150px",
                overflow: "auto"
            };

            return (
                <Fragment>
                    <div style={style} className={'ctf-yt_link-parent'}>
                        <div className={'ctf-yt_link-left'}>
                            {webspaces}
                        </div>
                    </div>
                </Fragment>
            );
        }
        catch (error)
        {
            console.log('There is no webspace array.');
        }


    }
}
